<div class="page-container">
  <div class="page-content">
    <div  *ngIf="currentQuestion" class="feedback-step">
      <mat-icon [ngClass]="geIconColorClass(step)"
        *ngFor="let step of answerStepFeedback">
        {{step}}
      </mat-icon>
    </div>

    <div *ngIf="currentQuestion" class="questions-container">
      <h3>{{currentQuestion.pergunta}}</h3>
      <div *ngFor="let answer of currentQuestion.respostas" (click)="handleSelectAwnser(answer.id)" class="awsner-item"
        [class.selected-awnser]="answer.id === selectedAnswer">
        <span>{{answer.texto}}</span>
      </div>
    </div>

    <ng-container *ngIf="!currentQuestion">
      <app-skeleton height="3rem" margin="2.5rem 0 0"></app-skeleton>
      <app-skeleton height="1.5rem" margin="1.5rem 0 0" width="11.25rem" mobileWidth="11.25rem"></app-skeleton>
      <app-skeleton height="3rem" margin="1.5rem 0 0" width="16rem"></app-skeleton>
      <app-skeleton height="3rem" margin="1.5rem 0 0" width="16rem"></app-skeleton>
      <app-skeleton height="3rem" margin="1.5rem 0 0" width="16rem"></app-skeleton>
    </ng-container>
    
    <div class="actions">
      <ng-container *ngIf="!currentQuestion">
        <app-skeleton height="3rem" [margin]="(isMinorThanTablet | async).matches ? '1.5rem 0 0' : '84px 0 0'"  width="15.9rem"></app-skeleton>
        <app-skeleton height="3rem" [margin]="(isMinorThanTablet | async).matches ? '3rem 0 0' : '84px 0 0'" width="15.9rem"></app-skeleton>
      </ng-container>

      <ng-container  *ngIf="currentQuestion">
        <button mat-stroked-button type="button" (click)="handleCancel()" tabindex="4" class="outlined" color="primary">
          Cancelar
        </button>
        <button tabindex="5" (click)="handleNextQuestion()" [disabled]="!selectedAnswer" mat-flat-button color="primary">
          <mat-icon class="spinner" color="default" *ngIf="loading">
            <mat-spinner diameter="20">
            </mat-spinner>
          </mat-icon>
          <span *ngIf="!loading">Continuar</span>
        </button>
      </ng-container>
    </div>
  </div>
</div>